import(/* webpackMode: "eager" */ "/vercel/path0/src/app/faq/page.jsx");
